import createDataReducer from "../../helpers/createDataReducer";
import deltas from "../../actions/deltas";

const {
    SET_ENROLMENTS_PAGINATION_DATA,
} = deltas.actionTypes;

export default createDataReducer(
    SET_ENROLMENTS_PAGINATION_DATA,
);
